function getValue(value, customValue = 'N/I') {
  console.log({ value, customValue })

  if (!value && typeof value === 'number') {
    return String(value)
  } else {
    return value || customValue
  }
}

module.exports = { getValue }
